import React, { createContext, useContext, ReactNode } from 'react';
import { useLoad } from './sw.hooks';

export interface ServiceWorkerContextType {
	serviceWorker: ServiceWorker | null;
	isReady: boolean;
	sendMessage: (message: any) => void;
}

export const ServiceWorkerContext = createContext<
	ServiceWorkerContextType | undefined
>(undefined);

export const useServiceWorkerContext = () => {
	const context = useContext(ServiceWorkerContext);
	if (context === undefined) {
		throw new Error(
			'useServiceWorkerContext must be used within a ServiceWorkerProvider',
		);
	}
	return context;
};

interface ServiceWorkerProviderProps {
	children: ReactNode;
}

export const ServiceWorkerProvider: React.FC<ServiceWorkerProviderProps> = ({
	children,
}) => {
	const serviceWorker = useLoad();
	const isReady = serviceWorker !== null;

	const sendMessage = (message: any) => {
		if (serviceWorker) {
			serviceWorker.postMessage(message);
		} else {
			console.warn(
				'Service Worker not available to send message:',
				message,
			);
		}
	};

	const value: ServiceWorkerContextType = {
		serviceWorker,
		isReady,
		sendMessage,
	};

	return (
		<ServiceWorkerContext.Provider value={value}>
			{children}
		</ServiceWorkerContext.Provider>
	);
};
